import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import { Box } from "@mui/material"
import MetricCard from "./MetricCard"
import BarChartCard from "./BarChartCard"
import {
  OVERVIEW_CARDS_GRID_GAP,
  overviewCardsGridSx3,
} from "./constants/overviewGrid"

const PlanSection = ({ data, isLoading }) => {
  const hasCostByTypeChart = (data?.costByTypeChart?.length ?? 0) > 0
  const showBottomSection = isLoading || hasCostByTypeChart

  const cards = (data?.cards ?? []).map(card => (
    <Box key={card.id ?? card.title} sx={{ minWidth: 0 }}>
      <MetricCard {...card} loading={isLoading} />
    </Box>
  ))

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={overviewCardsGridSx3}>
        {cards}
        {showBottomSection && (
          <Box
            sx={{
              gridColumn: "1 / -1",
              minWidth: 0,
              display: "grid",
              gridTemplateColumns: "minmax(0, 1fr)",
              gap: OVERVIEW_CARDS_GRID_GAP,
            }}
          >
            {(isLoading || hasCostByTypeChart) && (
              <BarChartCard
                title={i18n.t("overview.costByType")}
                infoText={i18n.t("overview.tooltip.costByType")}
                dataSource={data?.costByTypeChart ?? []}
                isLoading={isLoading}
                currency={data?.currency}
              />
            )}
          </Box>
        )}
      </Box>
    </Box>
  )
}

PlanSection.propTypes = {
  data: PropTypes.shape({
    currency: PropTypes.string,
    cards: PropTypes.arrayOf(PropTypes.object),
    costByTypeChart: PropTypes.arrayOf(PropTypes.object),
  }),
  isLoading: PropTypes.bool.isRequired,
}

export default PlanSection
